/* ------------------------------------------------------------------
   Codae — custom sort dropdown wiring
   The visible dropdown (.codae-sort) is a rounded, on-brand popup that
   mirrors a hidden native <select name="sort_by">. Choosing an option
   syncs that select and fires an `input` event so Dawn's facets.js
   applies the sort (AJAX). Listeners are delegated on `document` so
   they survive facets.js re-rendering the sorting bar.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var option = event.target.closest('.codae-sort__option');

    if (option) {
      var scope = option.closest('.facet-filters') || document;
      var select = scope.querySelector('select[name="sort_by"]');
      var details = option.closest('.codae-sort__details');

      if (select && select.value !== option.dataset.value) {
        select.value = option.dataset.value;
        // facets.js listens for `input` on the form (debounced) → AJAX.
        select.dispatchEvent(new Event('input', { bubbles: true }));
      }

      // Reflect the choice straight away; the AJAX re-render will also
      // come back from the server with the correct selected state.
      if (details) {
        var valueEl = details.querySelector('.codae-sort__value');
        if (valueEl) valueEl.textContent = option.textContent.trim();
        details.open = false;
      }
      return;
    }

    // A click anywhere outside an open dropdown closes it.
    document.querySelectorAll('.codae-sort__details[open]').forEach(function (d) {
      if (!d.contains(event.target)) d.open = false;
    });
  });

  // Escape closes any open sort dropdown.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.codae-sort__details[open]').forEach(function (d) {
      d.open = false;
    });
  });
})();
